import { FunctionComponent } from "react";
import classNames from "classnames";
import useBrowserDimensions from "../../utils/detectedDimension";
import GalleryTemplate from "./GalleryTemplate";

export interface IGalleryPhotos {
  configsFromLayout: any;
}

const GalleryPhotos: FunctionComponent<IGalleryPhotos> = ({
  configsFromLayout,
}) => {
  const { width, height } = useBrowserDimensions();
  const detectedPortrait = width < height;
  const duration = configsFromLayout.configs.duration.value * 1000;

  const getConfig = (key: string) => configsFromLayout?.configs?.[key]?.value;

  function MediaType(post: any, index: number) {
    if (typeof post === "string") {
      return (
        <img
          src={post}
          alt={`Slide ${index}`}
          className={
            getConfig("stretch_image")
              ? "w-full h-full object-cover"
              : "max-w-[100%] max-h-[100%] object-contain"
          }
        />
      );
    }
  }

  return (
    <GalleryTemplate
      shouldShowProfile
      configs={{
        autoplay: { delay: duration },
        grid: { rows: !detectedPortrait ? 2 : 3 },
        slidesPerView: !detectedPortrait ? 4.1 : 4,
        speed: 2500,
        transition: getConfig("transition"),
        className: classNames(
          !configsFromLayout.configs.logo.value &&
            !configsFromLayout.configs.title.value &&
            !configsFromLayout.configs.description.value
            ? "h-[96%]"
            : " h-[85%]",
          "w-full",
        ),
      }}
      children={configsFromLayout?.configs?.gallery?.value?.map(
        (post: any, index: number) => (
          <div
            key={index}
            className="w-full h-full p-[1.2vh] m-[1.2vh] flex justify-center"
          >
            {MediaType(post, index)}
          </div>
        ),
      )}
      configsFromLayout={configsFromLayout}
    />
  );
};

export default GalleryPhotos;
